import React, { Component } from 'react';

import {Container, Row, Col, Label, Input, Button, Nav, NavItem, NavLink, TabContent, TabPane} from 'reactstrap';
import { Redirect } from 'react-router-dom';

import api from '../../api'
import auth from '../../auth'
import axios from "axios";

import jsonToFormData from 'json-form-data';

import ParadigmaAsyncSeeker from "../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";

import './Escribania.css';

class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            propSelect:1,
            cantProp: 1,
            loteoSelect:1,
            cantLoteos:1,

            loteosArray: [{loteo_id: null, lote: '', manzana: '', certificadoLD: null, contrato: null, archivoContrato: null, archivoMunicipalidad: null, archivoAgua: null, archivoImpuestos: null,}],
            propietariosArray: [{apellidoNombre: '', tipoDocumento: 'DNI', domicilio: '', numero: '', piso: '', departamento: '', codPostal: '', localidad: null, provincia: null, dni: '', cuit: '', constancia: null, contacto: '', domicilio: '', contactoAlt: '', relacionTit: '', estadoCivil: '',}],

            contacto: '',
            contactoAlternativo: '',
            domicilio: '',

            loteo_id: null,
            lote: '',
            manzana: '',

            certificadoLD: null,

            contrato: null,
            archivoContrato: null,

            archivoMunicipalidad: null,
            archivoAgua: null,
            archivoImpuestos: null,
            error: {},

            success: false,
        };
    }

    validate = () => {
        const {propietariosArray, contacto, domicilio, loteo_id, lote, manzana, certificadoLD, contrato, archivoContrato,
            archivoMunicipalidad, archivoAgua, archivoImpuestos, loteoSelect, cantLoteos, loteosArray, cantProp, propSelect } = this.state;
        let emptyString = (data, desiredLength = 0) => data =! undefined && data != null && data.length >= desiredLength;

        let validate=true;
        let error = this.state.error;

        for (let j = 0; j < cantProp; j++) {
            if (emptyString(propietariosArray[j].dni, 2)==false){
                error['dni'+j] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (j+1)==propSelect) ? j : (encTabErrorProp ? tabErrorProp : j);
                encTabErrorProp = (encTabErrorProp==false && (j+1)==propSelect) ? true : encTabErrorProp;
            }else{
                error['dni'+j] = '';
            }

            if (emptyString(propietariosArray[j].cuit, 2)==false){
                error['cuit'+j] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (j+1)==propSelect) ? j : (encTabErrorProp ? tabErrorProp : j);
                encTabErrorProp = (encTabErrorProp==false && (j+1)==propSelect) ? true : encTabErrorProp;
            }else{
                error['cuit'+j] = '';
            }

            if (emptyString(propietariosArray[j].contacto, 2)==false){
                error['contacto'+j] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (j+1)==propSelect) ? j : (encTabErrorProp ? tabErrorProp : j);
                encTabErrorProp = (encTabErrorProp==false && (j+1)==propSelect) ? true : encTabErrorProp;
            }else{
                error['contacto'+j] = '';
            }

            if (emptyString(propietariosArray[j].domicilio, 2)==false){
                error['domicilio'+j] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (j+1)==propSelect) ? j : (encTabErrorProp ? tabErrorProp : j);
                encTabErrorProp = (encTabErrorProp==false && (j+1)==propSelect) ? true : encTabErrorProp;
            }else{
                error['domicilio'+j] = '';
            }

            if (emptyString(propietariosArray[j].apellidoNombre, 2)==false){
                error['apellidoNombre'+j] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (j+1)==propSelect) ? j : (encTabErrorProp ? tabErrorProp : j);
                encTabErrorProp = (encTabErrorProp==false && (j+1)==propSelect) ? true : encTabErrorProp;
            }else{
                error['apellidoNombre'+j] = '';
            }

        }

        let tabErrorProp = null;
        let encTabErrorProp = false;

        for (let i = 0; i < cantLoteos; i++) {

            if (loteosArray[i].loteo_id==null){
                error['loteo_id'+i] = 'Complete este campo';
                validate=false;
                tabError = (encTabErrorProp==false && (i+1)==loteoSelect) ? i : (encTabErrorProp ? tabErrorProp : i);
                encTabErrorProp = (encTabErrorProp==false && (i+1)==loteoSelect) ? true : encTabErrorProp;
            }else{
                error['loteo_id'+i] = '';
            }
        }

        let tabError = null;
        let encTabError = false;

        for (let i = 0; i < cantLoteos; i++) {

            if (loteosArray[i].loteo_id==null){
                error['loteo_id'+i] = 'Complete este campo';
                validate=false;
                tabError = (encTabError==false && (i+1)==loteoSelect) ? i : (encTabError ? tabError : i);
                encTabError = (encTabError==false && (i+1)==loteoSelect) ? true : encTabError;
            }else{
                error['loteo_id'+i] = '';
            }

            if (emptyString(loteosArray[i].lote, 1)==false){
                error['lote'+i] = 'Complete este campo';
                validate=false;
                tabError = (encTabError==false && (i+1)==loteoSelect) ? i : (encTabError ? tabError : i);
                encTabError = (encTabError==false && (i+1)==loteoSelect) ? true : encTabError;
            }else{
                error['lote'+i] = '';
            }

            if (emptyString(loteosArray[i].manzana, 1)==false){
                error['manzana'+i] = 'Complete este campo';
                validate=false;
                tabError = (encTabError==false && (i+1)==loteoSelect) ? i : (encTabError ? tabError : i);
                encTabError = (encTabError==false && (i+1)==loteoSelect) ? true : encTabError;
            }else{
                error['manzana'+i] = '';
            }

            if (loteosArray[i].certificadoLD==null){
                error['certificadoLD'+i] = 'Seleccione una opcion';
                validate=false;
                tabError = (encTabError==false && (i+1)==loteoSelect) ? i : (encTabError ? tabError : i);
                encTabError = (encTabError==false && (i+1)==loteoSelect) ? true : encTabError;
            }else{
                error['certificadoLD'+i] = '';
            }

            if (loteosArray[i].contrato==null){
                error['contrato'+i] = 'Seleccione una opcion';
                validate=false;
                tabError = (encTabError==false && (i+1)==loteoSelect) ? i : (encTabError ? tabError : i);
                encTabError = (encTabError==false && (i+1)==loteoSelect) ? true : encTabError;
            }else{
                error['contrato'+i] = '';
            }

        }

        this.setState({
            errors: error,
            loteoSelect: (tabError != null) ? (tabError+1) : (loteoSelect),
            propSelect: (tabErrorProp != null) ? (tabErrorProp+1) : (propSelect),
        })

        return validate;
    }

    EnviarForm = () => {
        const {propietariosArray, contacto, domicilio, loteo_id, lote, manzana, certificadoLD, contrato, archivoContrato,
                archivoMunicipalidad, archivoAgua, archivoImpuestos, cantProp, propSelect, loteoSelect, cantLoteos, loteosArray } = this.state;

        let validate=this.validate();

        if(validate==true){
            let documentosEscribania = propietariosArray;

            let arrayLotes = [
                {loteo_id: loteosArray[0].loteo_id,
                manzana: loteosArray[0].manzana,
                lote: loteosArray[0].lote,
                certificadoLD: loteosArray[0].certificadoLD,
                contrato: loteosArray[0].contrato,
                archivoContrato: loteosArray[0].archivoContrato,
                archivoMunicipalidad: loteosArray[0].archivoMunicipalidad,
                archivoAgua: loteosArray[0].archivoAgua,
                archivoImpuestos: loteosArray[0].archivoImpuestos,}
            ];

            if (cantLoteos>=2){
                arrayLotes.push(
                    {loteo_id: loteosArray[1].loteo_id,
                    manzana: loteosArray[1].manzana,
                    lote: loteosArray[1].lote,
                    certificadoLD: loteosArray[1].certificadoLD,
                    contrato: loteosArray[1].contrato,
                    archivoContrato: loteosArray[1].archivoContrato,
                    archivoMunicipalidad: loteosArray[1].archivoMunicipalidad,
                    archivoAgua: loteosArray[1].archivoAgua,
                    archivoImpuestos: loteosArray[1].archivoImpuestos,}
                )
            }

            if (cantLoteos>=3){
                arrayLotes.push(
                    {loteo_id: loteosArray[2].loteo_id,
                    manzana: loteosArray[2].manzana,
                    lote: loteosArray[2].lote,
                    certificadoLD: loteosArray[2].certificadoLD,
                    contrato: loteosArray[2].contrato,
                    archivoContrato: loteosArray[2].archivoContrato,
                    archivoMunicipalidad: loteosArray[2].archivoMunicipalidad,
                    archivoAgua: loteosArray[2].archivoAgua,
                    archivoImpuestos: loteosArray[2].archivoImpuestos,}
                )
            }

            if (cantLoteos>=4){
                arrayLotes.push(
                    {loteo_id: loteosArray[3].loteo_id,
                    manzana: loteosArray[3].manzana,
                    lote: loteosArray[3].lote,
                    certificadoLD: loteosArray[3].certificadoLD,
                    contrato: loteosArray[3].contrato,
                    archivoContrato: loteosArray[3].archivoContrato,
                    archivoMunicipalidad: loteosArray[3].archivoMunicipalidad,
                    archivoAgua: loteosArray[3].archivoAgua,
                    archivoImpuestos: loteosArray[3].archivoImpuestos,}
                )
            }

            let data = {"contacto": '', // "contacto": loteosArray[0].contacto,
                        "domicilio": '', // "domicilio": loteosArray[0].domicilio,
                        // "loteo_id": loteosArray[0].loteo_id,
                        "manzana": '', // "manzana": loteosArray[0].manzana,
                        "lote": '', // "lote": loteosArray[0].lote,
                        "certificadoLD": false, // "certificadoLD": loteosArray[0].certificadoLD,
                        "contrato": 1, // "contrato": loteosArray[0].contrato,
                        "archivoContrato": null, // "archivoContrato": loteosArray[0].archivoContrato,
                        "archivoMunicipalidad": null, // "archivoMunicipalidad": loteosArray[0].archivoMunicipalidad,
                        "archivoAgua": null, // "archivoAgua": loteosArray[0].archivoAgua,
                        "archivoImpuestos": null, // "archivoImpuestos": loteosArray[0].archivoImpuestos,
                        "documentosEscribania": documentosEscribania,
                        "arrayLotes":arrayLotes,
                    }

            let Formdata = jsonToFormData(data);

            axios.post(api.escribania.escribania, Formdata)
            .then(response => {
                if(response.data && response.data.meta && response.data.meta.allowed == true){
                    this.setState({success:true});
                }else{
                    window.scrollTo(0,0);
                    this.setState({success:false, errMsg:"Ocurrio un error en el servidor, reintente en unos momentos."});
                    setTimeout(
                        ()=>this.setState({success:false,disableBtn:false, errMsg:""}),
                        5000
                    );
                }
            }).catch(error => {
                window.scrollTo(0,0);
                this.setState({success:false,disableBtn:false, errMsg:"Ocurrio un error en el servidor, reintente en unos momentos."});
                setTimeout(
                    ()=>this.setState({success:false,disableBtn:false, errMsg:""}),
                    5000
                );
            });
        }
    }

    cantLotes = (cantLoteos, loteoSelect) => { //Cambio cantidad Loteos
        let loteosArrayAux = this.state.loteosArray;
        var loteosArray = []
          for (var i = 0; i < cantLoteos; i++) {
                if(i<loteosArrayAux.length){
                    loteosArray.push(loteosArrayAux[i]);
                }else{
                    loteosArray.push({loteo_id: null, lote: '', manzana: '', certificadoLD: null, contrato: null, archivoContrato: null, archivoMunicipalidad: null, archivoAgua: null, archivoImpuestos: null,});
                }
          }
        this.setState({cantLoteos: cantLoteos,
                        loteoSelect: loteoSelect,
                        loteosArray: loteosArray});
    }

    cantPropietarios = (cantProp, propSelect) => { //Cambio cantidad Propietario
        let propietariosArrayAux = this.state.propietariosArray;
        var propietariosArray = []
          for (var i = 0; i < cantProp; i++) {
                if(i<propietariosArrayAux.length){
                    propietariosArray.push(propietariosArrayAux[i]);
                }else{
                    propietariosArray.push({apellidoNombre: '', tipoDocumento: 'DNI', domicilio: '', numero: '', piso: '', departamento: '', codPostal: '', localidad: null, provincia: null, dni: '', cuit: '', constancia: null, contacto: '', domicilio: '', contactoAlt: '', relacionTit: '', estadoCivil: '',});
                }
          }
        this.setState({cantProp: cantProp,
                        propSelect: propSelect,
                        propietariosArray: propietariosArray});
    }

    changeLoteosArray = (i, field, value, errors) =>{
        let loteosArray = this.state.loteosArray;

        loteosArray[i][field]= value;

        this.setState({loteosArray: loteosArray, error:errors});
    }

    changePropietarioArray = (i, field, value, errors) =>{
        let propietariosArray = this.state.propietariosArray;

        propietariosArray[i][field]= value;

        if(field=='provincia'){
            propietariosArray[i]['localidad']=null;
        }

        this.setState({propietariosArray: propietariosArray, error:errors});
    }

    componentDidMount = () => {
        document.body.classList.add('eBody');
    }

    render() {
        if(this.state.success == true){
            return (<Redirect to="/escribaniaexito"/>);
        }else{
            const {propietariosArray, contacto, domicilio,
                    loteo_id, lote, manzana, certificadoLD, contrato, archivoContrato, archivoMunicipalidad, archivoAgua, archivoImpuestos, error, cantProp, propSelect, loteoSelect, cantLoteos, loteosArray } = this.state;

            const regexpNumber = new RegExp(`^-?[0-9]*$`);
            const regexpText = new RegExp(`^-?[a-z,A-Z, ]*$`);

            const tabPropietarioContent = [];

            for (var j = 0; j < cantProp; j++) {
                const y = j;
                tabPropietarioContent.push((

                <TabPane tabId={(y+1)} className="py-1">
                <Row className={'py-3'}>
                    <Col className='col-12'>
                        <Label className={'ePropietarioTitle'}> {'Propietario '+(y+1)} </Label>
                    </Col>

                    <Col className="col-12 col-md-12 col-lg-6">
                        <ParadigmaLabeledInput
                            label={"Apellido y Nombre"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['apellidoNombre'+y]) ? (error['apellidoNombre'+y]) : ('')}]}}
                            value={propietariosArray[y].apellidoNombre}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['apellidoNombre'+y]=''; this.changePropietarioArray(y,'apellidoNombre', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-4">
                        <ParadigmaLabeledInput
                            label={"Estado Civil"}
                            classNames={['eLblForm', 'eInpForm']}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    url={api.configuracion.estadocivil}
                                    parameters={{
                                        paginationEnabled:false,
                                        sort:['nombre']
                                    }}
                                    value={propietariosArray[y].estadoCivil}
                                    onChange={data => this.changePropietarioArray(y, 'estadoCivil', (data) ? (data.id) : (null), error)}
                                />
                            }
                        />
                    </Col>

                    <Col className="col-12 col-md-3 col-lg-2">
                        <ParadigmaLabeledInput
                            label={"C. P."}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['codPostal'+y]) ? (error['codPostal'+y]) : ('')}]}}
                            value={propietariosArray[y].codPostal}
                            maxLength={5}
                            onChange={e => {let errors = error; errors['codPostal'+y]='';  this.changePropietarioArray(y, 'codPostal', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-4">
                        <ParadigmaLabeledInput
                            label={"Nacionalidad"}
                            classNames={['eLblForm', 'eInpForm']}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    url={api.geograficas.nacionalidades}
                                    parameters={{
                                        paginationEnabled:false,
                                        sort:['nombre']
                                    }}
                                    value={propietariosArray[y].nacionalidad}
                                    onChange={data => this.changePropietarioArray(y, 'nacionalidad', (data) ? (data.id) : (null), error)}
                                />
                            }
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-4">
                        <ParadigmaLabeledInput
                            label={"Provincia"}
                            classNames={['eLblForm', 'eInpForm']}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    url={api.geograficas.provincias}
                                    parameters={{
                                        paginationEnabled:false,
                                    sort:['nombre']
                                    }}
                                    value={propietariosArray[y].provincia}
                                    onChange={data => {this.changePropietarioArray(y, 'provincia', (data) ? (data.id) : (null), error);}}
                                />
                            }
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-4">
                        <ParadigmaLabeledInput
                            label={"Localidad"}
                            classNames={['eLblForm', 'eInpForm']}
                            inputComponent={
                                <ParadigmaAsyncSeeker
                                    clearable={false}
                                    url={propietariosArray[y].provincia ? api.geograficas.localidades : ''}
                                    parameters={{
                                        paginationEnabled:false,
                                        sort:['nombre'],
                                        concat:propietariosArray[y].provincia ? `provincia=${propietariosArray[y].provincia}` : ''
                                    }}
                                    value={propietariosArray[y].localidad}
                                    onChange={data => this.changePropietarioArray(y, 'localidad', (data) ? (data.id) : (null), error)}
                                />
                            }
                        />
                    </Col>

                    <Col className="col-12 col-md-4 col-lg-2">
                        <ParadigmaLabeledInput
                            label={"Tipo Doc."}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['tipoDocumento'+y]) ? (error['tipoDocumento'+y]) : ('')}]}}
                            inputComponent={
                                <Input
                                    type={'select'}
                                    value={propietariosArray[y].tipoDocumento}
                                    onChange={e => {let errors = error; errors['tipoDocumento'+y]=''; this.changePropietarioArray(y, 'tipoDocumento', e.target.value, errors)}}
                                    className="form-control"
                                    >
                                        <option value={'DNI'}>DNI</option>
                                        <option value={'Pasaporte'}>Pasaporte</option>
                                </Input>}
                        />
                    </Col>

                    <Col className="col-12 col-md-4 col-lg-3">
                        <ParadigmaLabeledInput
                            label={"Nro. Documento"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['dni'+y]) ? (error['dni'+y]) : ('')}]}}
                            value={propietariosArray[y].dni}
                            maxLength={10}
                            onChange={e => {let errors = error; errors['dni'+y]=''; this.changePropietarioArray(y, 'dni', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-4 col-lg-3">
                        <ParadigmaLabeledInput
                            label={"CUIT/CUIL"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['cuit'+y]) ? (error['cuit'+y]) : ('')}]}}
                            value={propietariosArray[y].cuit}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['cuit'+y]=''; this.changePropietarioArray(y, 'cuit', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-4">
                        <ParadigmaLabeledInput
                            label={"Domicilio"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['domicilio'+y]) ? (error['domicilio'+y]) : ('')}]}}
                            value={propietariosArray[y].domicilio}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['domicilio'+y]=''; this.changePropietarioArray(y, 'domicilio', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-4 col-lg-2">
                        <ParadigmaLabeledInput
                            label={"N°"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['numero'+y]) ? (error['numero'+y]) : ('')}]}}
                            value={propietariosArray[y].numero}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['numero'+y]=''; this.changePropietarioArray(y, 'numero', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-4 col-lg-2">
                        <ParadigmaLabeledInput
                            label={"Piso"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['piso'+y]) ? (error['piso'+y]) : ('')}]}}
                            value={propietariosArray[y].piso}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['piso'+y]=''; this.changePropietarioArray(y, 'piso', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-3 col-lg-2">
                        <ParadigmaLabeledInput
                            label={"Departamento"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['departamento'+y]) ? (error['departamento'+y]) : ('')}]}}
                            value={propietariosArray[y].departamento}
                            maxLength={20}
                            onChange={e => {let errors = error; errors['departamento'+y]=''; this.changePropietarioArray(y, 'departamento', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-6">
                        <ParadigmaLabeledInput
                            label={"Contacto"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['contacto'+y]) ? (error['contacto'+y]) : ('')}]}}
                            value={propietariosArray[y].contacto}
                            maxLength={100}
                            onChange={e => {let errors = error; errors['contacto'+y]=''; this.changePropietarioArray(y, 'contacto', e.target.value, errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-6">
                        <ParadigmaLabeledInput
                            label={"Contacto Alternativo"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['contactoAlt'+y]) ? (error['contactoAlt'+y]) : ('')}]}}
                            value={propietariosArray[y].contactoAlt}
                            maxLength={100}
                            onChange={e => {let errors = error; errors['contactoAlt'+y]=''; this.changePropietarioArray(y, 'contactoAlt', (regexpNumber.test(e.target.value)) ? (e.target.value) : (propietariosArray[y].contactoAlt), errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-6">
                        <ParadigmaLabeledInput
                            label={"Relacion Titular"}
                            classNames={['eLblForm', 'eInpForm']}
                            error={() => {return [{detail: (error['relacionTit'+y]) ? (error['relacionTit'+y]) : ('')}]}}
                            value={propietariosArray[y].relacionTit}
                            maxLength={100}
                            onChange={e => {let errors = error; errors['relacionTit'+y]=''; this.changePropietarioArray(y, 'relacionTit', (regexpText.test(e.target.value)) ? (e.target.value) : (propietariosArray[y].relacionTit), errors)}}
                        />
                    </Col>

                    <Col className="col-12 col-md-6 col-lg-6">
                        <ParadigmaLabeledInput
                            label={"Constancia"}
                            classNames={['eLblForm', '']}
                            inputComponent={
                                <Input
                                onChange={e => this.changePropietarioArray(y, 'constancia', e.target.files[0], error)  }
                                type="file" />
                            }
                        />
                    </Col>

                </Row>
                </TabPane>
            ));}

            const tabLoteosContent = [];
            for (var i = 0; i < cantLoteos; i++) {
                const x = i;
                tabLoteosContent.push((

                    <TabPane tabId={x+1} className="py-1">
                        <Row className={'mt-2'}>
                            <Col className='col-12'>
                                <h5 className={'eSubtitle'}>Antecedentes del dominio</h5>
                            </Col>
                        </Row>
                        <Row className={'pl-1 pr-1'}>

                            <Col className="col-12 col-md-6 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    label={"Loteo"}
                                    classNames={['eLblForm', 'eInpForm']}
                                    error={() => {return [{detail: (error['loteo_id'+x]) ? (error['loteo_id'+x]) : ('')}]}}
                                    inputComponent={
                                        <ParadigmaAsyncSeeker
                                            clearable={false}
                                            url={api.loteos.loteos_select}
                                            parameters={{
                                                paginationEnabled:false,
                                                    sort:['nombre']
                                            }}
                                            value={loteosArray[x].loteo_id}
                                            onChange={e=>{let errors = error; errors['loteo_id'+x]=''; this.changeLoteosArray(x, 'loteo_id', (e) ? (e.id) : null, errors)}}
                                        />
                                    }
                                />
                            </Col>
                            <Col className="col-12 col-md-6 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    // md={[3, 9]}
                                    label={"Manzana"}
                                    classNames={['eLblForm', 'eInpForm']}
                                    error={() => {return [{detail: (error['manzana'+x]) ? (error['manzana'+x]) : ('')}]}}
                                    value={loteosArray[x].manzana}
                                    maxLength={100}
                                    onChange={e => {let errors = error; errors['manzana'+x]=''; this.changeLoteosArray(x, 'manzana', e.target.value, errors)}}
                                />
                            </Col>
                            <Col className="col-12 col-md-6 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    // md={[3, 9]}
                                    label={"Lote"}
                                    classNames={['eLblForm', 'eInpForm']}
                                    error={() => {return [{detail: (error['lote'+x]) ? (error['lote'+x]) : ('')}]}}
                                    value={loteosArray[x].lote}
                                    maxLength={100}
                                    onChange={e => {let errors = error; errors['lote'+x]=''; this.changeLoteosArray(x, 'lote', e.target.value, errors)}}
                                />
                            </Col>

                            <Col className="col-12 col-lg-12 mt-2">
                                <Row>
                                    <Col className="col-12 col-lg-5">
                                        <ParadigmaLabeledInput
                                            label={"Posee certificado cancelación total del precio total?"}
                                            classNames={['eLblForm', 'eInpForm']}
                                            error={() => {return [{detail: (error['certificadoLD'+x]) ? (error['certificadoLD'+x]) : ('')}]}}
                                            inputComponent={
                                                <Input
                                                    type={'select'}
                                                    value={loteosArray[x].certificadoLD}
                                                    onChange={(e) => {let errors = error; errors['certificadoLD'+x]=''; this.changeLoteosArray(x, 'certificadoLD', (e.target.value=='true') ? (true) : ((e.target.value=='false') ? (false) : (null)), errors)}}
                                                    className="form-control"
                                                    >
                                                        <option value={'null'}>Seleccionar</option>
                                                        <option value={true}>Si</option>
                                                        <option value={false}>No</option>
                                                </Input>}
                                        />
                                    </Col>
                                    {(loteosArray[x].certificadoLD==false) &&
                                    <Col className="col-12 col-lg-7 pt-2">
                                        <Row>
                                            <Col className='d-none d-sm-none d-md-block col-lg-12'>
                                                <Label>
                                                    {''}
                                                </Label>
                                            </Col>
                                        </Row>
                                        <Row>
                                        <Col className='col-12'>
                                            <span className={'elblMsj'}>Diríjase a una oficina de Grupo Bartolome</span>
                                        </Col>
                                        </Row>
                                    </Col>}

                                </Row>
                            </Col>

                            <Col className="col-12 col-md-6 col-lg-6 mt-2">
                                <ParadigmaLabeledInput
                                    // md={[3, 9]}
                                    label={"Contrato"}
                                    classNames={['eLblForm', 'eInpForm']}
                                    error={() => {return [{detail: (error['contrato'+x]) ? (error['contrato'+x]) : ('')}]}}
                                    inputComponent={
                                        <Input
                                            type={'select'}
                                            value={loteosArray[x].contrato}
                                            onChange={(e) => {let errors = error; errors['contrato'+x]=''; this.changeLoteosArray(x, 'contrato', (e.target.value!='null') ? (e.target.value) : (null), errors)}}
                                            className="form-control"
                                            >
                                                <option value={'null'}>Seleccionar</option>
                                                <option value={1}>Fideicomiso</option>
                                                <option value={2}>Boleto de compraventa</option>
                                                <option value={3}>Cesión de derechos</option>
                                        </Input>}
                                />
                            </Col>

                            <Col className="col-12 col-md-12 col-lg-6 mt-2">
                                <ParadigmaLabeledInput
                                    label={"Archivo"}
                                    classNames={['eLblForm', '']}
                                    inputComponent={
                                        <Input onChange={e => this.changeLoteosArray(x, 'archivoContrato', e.target.files[0], error)} type="file" />
                                    }
                                />
                            </Col>

                            <Col className="col-12 col-md-12 col-lg-12">
                                <Label className={'emcontrato'}>De no estar sellado acercarse o comunicarse con la inmobiliaria</Label>
                            </Col>
                        </Row>

                        <Row className={'mt-4'}>
                            <Col className='col-12'>
                                <h5 className={'eSubtitle'}>Pagos de los tributos</h5>
                            </Col>
                        </Row>
                        <Row className={'pl-3 pr-3'}>

                            <Col className="col-12 col-md-12 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    label={"Municipalidad"}
                                    classNames={['eLblForm', '']}
                                    inputComponent={
                                        <Input onChange={e => this.changeLoteosArray(x, 'archivoMunicipalidad', e.target.files[0], error)} type="file" />
                                    }
                                />
                            </Col>

                            <Col className="col-12 col-md-12 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    label={"Agua"}
                                    classNames={['eLblForm', '']}
                                    inputComponent={
                                        <Input onChange={e => this.changeLoteosArray(x, 'archivoAgua', e.target.files[0], error)} type="file" />
                                    }
                                />
                            </Col>

                            <Col className="col-12 col-md-12 col-lg-4 mt-2">
                                <ParadigmaLabeledInput
                                    label={"Imp. de Renta Inmobiliario"}
                                    classNames={['eLblForm', '']}
                                    inputComponent={
                                        <Input onChange={e => this.changeLoteosArray(x, 'archivoImpuestos', e.target.files[0], error)} type="file" />
                                    }
                                />
                            </Col>

                        </Row>

                    </TabPane>
                ));
            }

            return (
                <Container className='econtainer_form mt-3 mb-5'>
                    <Row className="align-items-end">
                        <Col className={'col-12 col-md-4'}>
                            <div className='eImgCont'></div>
                        </Col>
                        <Col className={'col-12 col-md-8'}>
                            <h3 className={'eTitle mb-5 mt-2'}>Formulario Escribanía</h3>
                        </Col>
                    </Row>

                    <Row className={'py-4 px-1 px-sm-4'}>
                        <Col className="col-12">
                        <Row>
                            <Col className='col-12'>
                                <h4 className={'eSubtitle'}> Datos de los titulares </h4>
                            </Col>
                        </Row>

                        <Row>
                            <Col className="col-12 col-md-6 col-lg-4 my-2 ml-3">
                                <ParadigmaLabeledInput
                                    label={"Cantidad Titulares"}
                                    classNames={['eLblForm pl-0', '']}
                                    inputComponent={
                                        <Row>
                                            <Button className={'eMenosProp'} onClick={()=>{let cant=(cantProp!=1) ? (cantProp-1) : (1); this.cantPropietarios(cant, (cant>propSelect) ? (propSelect) : (cant))}}>
                                                <i class="fa fa-minus"/>
                                            </Button>
                                            <Input className={'eCantProp'} value={cantProp} disabled onChange={()=>{}} type="text" />
                                            <Button className={'eMasProp'} onClick={()=>{{let cant=(cantProp!=4) ? (cantProp+1) : (4); this.cantPropietarios(cant, propSelect)}}}> <i class="fa fa-plus"/> </Button>
                                        </Row>
                                    }
                                />
                            </Col>

                            <Col className='col-12'>
                                <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={(propSelect == 1 ? 'active eNavItem' : '')}
                                        onClick={() => { this.setState({ propSelect: 1 }) }}
                                    >Propietario 1</NavLink>
                                </NavItem>

                                {(cantProp>=2) &&
                                    <NavItem>
                                        <NavLink
                                            className={(propSelect == 2 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ propSelect: 2 }) }}
                                        >Propietario 2</NavLink>
                                    </NavItem>
                                }

                                {(cantProp>=3) &&
                                    <NavItem>
                                        <NavLink
                                            className={(propSelect == 3 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ propSelect: 3 }) }}
                                        >Propietario 3</NavLink>
                                    </NavItem>
                                }

                                {(cantProp>=4) &&
                                    <NavItem>
                                        <NavLink
                                            className={(propSelect == 4 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ propSelect: 4 }) }}
                                        >Propietario 4</NavLink>
                                    </NavItem>
                                }
                                </Nav>

                                <TabContent
                                    activeTab={propSelect}
                                    className={'pb-2 eTabCont'}
                                >

                                    {tabPropietarioContent}

                                </TabContent>
                            </Col>
                        </Row>

                        </Col>
                    </Row>

                    <Row className={'py-4 px-1 px-sm-4 my-sm-3'}>
                        <Col className="col-12">
                            <Row>
                                <Col className='col-12'>
                                    <h4 className={'eSubtitle'}>Loteos</h4>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="col-12 col-md-6 col-lg-4 my-2 ml-3">
                                    <ParadigmaLabeledInput
                                        label={"Cantidad Lotes"}
                                        classNames={['eLblForm pl-0', '']}
                                        inputComponent={
                                            <Row>
                                                <Button className={'eMenosProp'} onClick={()=>{let cant=(cantLoteos!=1) ? (cantLoteos-1) : (1); this.cantLotes(cant, (cant>loteoSelect) ? (loteoSelect) : (cant))}}>
                                                    <i class="fa fa-minus"/>
                                                </Button>
                                                <Input className={'eCantProp'} value={cantLoteos} disabled onChange={()=>{}} type="text" />
                                                <Button className={'eMasProp'} onClick={()=>{{let cant=(cantLoteos!=4) ? (cantLoteos+1) : (4); this.cantLotes(cant, loteoSelect)}}}> <i class="fa fa-plus"/> </Button>
                                            </Row>

                                        }
                                    />
                                </Col>
                            </Row>

                            <Nav tabs>
                                <NavItem>
                                    <NavLink
                                        className={(loteoSelect == 1 ? 'active eNavItem' : '')}
                                        onClick={() => { this.setState({ loteoSelect: 1 }) }}
                                    >Lote 1</NavLink>
                                </NavItem>

                                {(cantLoteos>=2) &&
                                    <NavItem>
                                        <NavLink
                                            className={(loteoSelect == 2 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ loteoSelect: 2 }) }}
                                        >Lote 2</NavLink>
                                    </NavItem>
                                }

                                {(cantLoteos>=3) &&
                                    <NavItem>
                                        <NavLink
                                            className={(loteoSelect == 3 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ loteoSelect: 3 }) }}
                                        >Lote 3</NavLink>
                                    </NavItem>
                                }

                                {(cantLoteos>=4) &&
                                    <NavItem>
                                        <NavLink
                                            className={(loteoSelect == 4 ? 'active eNavItem' : '')}
                                            onClick={() => { this.setState({ loteoSelect: 4 }) }}
                                        >Lote 4</NavLink>
                                    </NavItem>
                                }
                            </Nav>

                            <TabContent
                                activeTab={loteoSelect}
                                className={'p-3 eTabCont'}
                            >
                                {tabLoteosContent}
                            </TabContent>

                        </Col>
                    </Row>

                    <Row className={'py-4 px-1 px-sm-5'}>
                        <Col className="col-12 col-sm-8 offset-sm-2 text-center eMFooter">
                            <Label className={'eMTitle'}>¡Importante!</Label>
                            <br/>
                            <Label>Acercarse a la escribanía correspondiente con copia y original</Label><br/>
                            <ul className="text-left ml-5 mt-2">
                                <li>Dni</li>
                                <li>Cuit/CUIL</li>
                                <li>Contrato sellado ante Renta</li>
                                <li>Certificado libre de deudas emitido por Grupo Bartolome S.A.</li>
                                <li>Comprobante de pago al día de los tributos</li>
                            </ul>
                        </Col>
                    </Row>

                    <Row className={'mt-3 mb-4 py-2 px-1 px-sm-4'}>
                        <Col className="col-12">
                            <Button color={'success'} size="lg" className={'eBtnForm'} onClick={()=>this.EnviarForm()}>Enviar</Button>
                        </Col>
                    </Row>

                    <Row className={'py-4 px-1 px-sm-4'}>
                        <Col className="col-12 col-sm-4 eMFooter text-center">
                            <Label className={'eMTitle logoFooter'}></Label>
                            <Label style={{top: "-1rem", position: "relative"}}>
                            <i class="fa fa-facebook eIRedes"/> <a href='https://es-es.facebook.com/pages/category/Organization/Grupo-Bartolome-195412370824156/' target='_blank'>Grupo Bartolome</a></Label>
                        </Col>
                        <Col className="col-12 col-sm-4 eMFooter">
                            <Label className={'eMSubTitle mt-2'}>Ofina de Roca</Label><br/>
                            <Label><i class="fa fa-envelope"/> loteo_jockey@hotmail.com.ar</Label><br/>
                            <Label><i class="fa fa-phone"/> 298-4753957</Label><br/>
                        </Col>
                        <Col className="col-12 col-sm-4 eMFooter">
                            <Label className={'eMSubTitle mt-2'}>Ofina de Cipolletti</Label><br/>
                            <Label><i class="fa fa-envelope"/> administracion@grupobartolome.com</Label><br/>
                            <Label><i class="fa fa-phone"/> 299-5328768</Label><br/>
                        </Col>
                    </Row>
                </Container>
            )
        }
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Escribania/Escribania.js